import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-documentdownload',
    templateUrl: './documentdownload.component.html',
    styleUrls: ['./documentdownload.component.scss'],
})
export class DocumentDownload implements OnInit {
    public documentdownloadform: FormGroup;
    languageConext: any;
    headerTitle: any;
    currentpath;
    formsubmitted: boolean = false;
    freq: any;
    todaydate: any;
    startFreqDate: any;
    years: any;
    fromdate: any;
    todate: any;
    language: any;
    fromdateacc: any;
    todateacc: any;
    datestatus: any;

    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        public api: RestapiService,
        public _sanitizer: DomSanitizer,
        public actionVal: ActionlistenService) {
        this.currentpath = this.router.url;
        this.todaydate = new Date();
        this.language = localStorage.getItem('language')
        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0];
            console.log(this.languageConext.downloadHeaderType)
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0];
            console.log(this.languageConext)
        }
        console.log(this.cmndef.headerType);
        this.headerTitle = this.languageConext.downloadHeaderType[this.cmndef.headerType];
        console.log("heder titile", this.headerTitle);
        this.freq = localStorage.getItem('policyFreq');

        this.documentdownloadform = formBuilder.group({
            fromdate: ['', Validators.required],
            todate: ['', Validators.required],
        });

    }
    ngOnInit() {

        if (this.headerTitle.header == 'Account Statement' || this.headerTitle.header == 'अकाउंट स्टेटमेंट') {
            this.datestatus = false;
        } else {
            this.datestatus = true;
        }
        if (this.freq != undefined) {
            localStorage.removeItem('policyFreq');
            if (this.freq == "Half Yearly" || this.freq == "Annual" || this.freq == "Single") {
                this.headerTitle.year = true;
                this.startFreqDate = null;
            } else if (this.freq == "Monthly" || this.freq == "Quarterly") {
                this.headerTitle.year = false;
                var today = new Date();
                var priorDate = new Date().setDate(today.getDate() - 90);
                console.log(new Date(priorDate));
                this.startFreqDate = new Date(priorDate).toISOString();
                console.log(this.startFreqDate);
            } else {
                console.log("else")
            }
        }
        let date = new Date();

        this.years = moment(new Date(date.setFullYear(date.getFullYear() - 4))).format('YYYY');
        console.log(this.years)
        if (this.headerTitle.year) {
            this.fromdate = moment(new Date()).format('YYYY');
            this.todate = moment(new Date()).format('DD/MM/YYYY');
        }
    }

    showDatepicker() {
        console.log(this.startFreqDate)
        let fulldate;
        let mdte;
        if (this.fromdate == undefined || this.fromdate == null || this.fromdate == "") {

            if (this.startFreqDate == undefined || this.startFreqDate == "") {
                var today = new Date();
                this.startFreqDate = new Date().setDate(today.getDate() - 90);
            }

            if (this.headerTitle.header == 'Account Statement' || this.headerTitle.header == 'अकाउंट स्टेटमेंट') {
                fulldate = new Date();

                mdte = new Date();
            } else {
                fulldate = new Date(this.startFreqDate);

                mdte = new Date(this.startFreqDate);
            }
            this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
                this.fromdate = data;
                console.log("first", this.fromdate)
            }, err => {
                console.log(err);
            })

        }
        else {
            let fromsplit = this.fromdate;
            let split = fromsplit.split("/");
            let sdate = split[1] + "/" + split[0] + "/" + split[2]
            var d = new Date(sdate);
            let mdte = new Date();
            this.cmndef.showdatePicker(d, "", mdte).then(data => {
                this.fromdate = data;
                console.log("sec", this.fromdate)
            }, err => {
                console.log(err);
            });
        }
    }

    showtoDatepicker() {
        if (this.headerTitle.header == 'Account Statement' || this.headerTitle.header == 'अकाउंट स्टेटमेंट') {

            if (this.todate == undefined || this.todate == null || this.todate == "") {
                var today = new Date();
                let tominsplit = this.fromdate.split("/");
                let tomindate = tominsplit[1] + "/" + tominsplit[0] + "/" + tominsplit[2]
                this.cmndef.showdatePicker(today, tomindate, today).then(data => {
                    this.todate = data;
                    console.log("first", this.todate)
                }, err => {
                    console.log(err);
                })

            }
            else {
                let tosplit = this.todate;
                let split = tosplit.split("/");
                let sdate = split[1] + "/" + split[0] + "/" + split[2]
                let tominsplit = this.fromdate.split("/");
                let tomindate = tominsplit[1] + "/" + tominsplit[0] + "/" + tominsplit[2]
                var d = new Date(sdate);
                let mdte = new Date();
                this.cmndef.showdatePicker(d, tomindate, mdte).then(data => {
                    this.todate = data;
                    console.log("sec", this.todate)
                }, err => {
                    console.log(err);
                });
            }
        }
    }


    changedate() {

        if (this.headerTitle.header == 'Account Statement' || this.headerTitle.header == 'अकाउंट स्टेटमेंट') {

            this.todate = null;
            this.datestatus = false;
  
        } else {
            this.datestatus = true;
            if (!this.cmndeclaration.cordovaSupport) {
                console.log(moment(new Date(this.fromdate)).add("3", "months").add("-1", "days"));
                this.todate = moment(new Date(this.fromdate)).add("3", "months").add("-1", "days").format("DD/MM/YYYY");
                console.log(this.todate)
            }
            else {
                console.log(this.fromdate);
                let dmo = this.fromdate.split("/");
                let val = dmo[1] + "/" + dmo[0] + "/" + dmo[2]
                console.log(moment(new Date(val)).add("3", "months").add("-1", "days"));
                this.todate = moment(new Date(val)).add("3", "months").add("-1", "days").format("DD/MM/YYYY");
                // let split = tdate.split("/");
                // this.todate = split[1] + "/" + split[0] + "/" + split[2];
                console.log(this.todate);
            }
        }


    }


    async submit() {
        // if (this.documentdownloadform.valid) {
        let params: any = {};
        params.userSessionId = localStorage.userSessionID;
        params.userChatSessionId = localStorage.userChatSessionId;
        if (this.fromdate != "" && this.fromdate != undefined && ((this.headerTitle.year == true) || (this.headerTitle.year == false && this.todate != "" && this.todate != undefined))) {
            if (!this.headerTitle.year) {
                console.log("fromdate", this.fromdate);
                console.log("todate", this.todate);
                params.startDate = this.fromdate;
                params.endDate = this.todate;
            }
            else if (this.freq == "Half Yearly" || this.freq == "Annual" || this.freq == "Single") {
                let yr = moment(this.fromdate).format("YYYY");
                console.log(yr);
                params.startDate = moment(new Date('04/01/' + yr)).format('DD/MM/YYYY');
                params.endDate = moment(new Date('04/01/' + yr)).add("1", "years").add("-1", "days").format('DD/MM/YYYY');
            }
            else {
                let yr = moment(this.fromdate).format("YYYY");
                let st = moment(new Date('04/01/' + yr)).format('DD/MM/YYYY');
                params.startDate = moment(new Date('04/01/' + yr)).format('DD/MM/YYYY');
                params.endDate = moment(new Date(st)).add("-1", "years").add("-1", "days").format('DD/MM/YYYY');
            }
            params.type = this.headerTitle.urlType
            await this.cmndef.loaderstart();
            this.api.clickenventcap("submit_"+this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
            await this.api.postapi("documentDownload", params).then(response => {
                let msg = response['message'];
                if ((response['responseCode'] == "001" && msg.indexOf('no') == -1 && this.language == 'en') || (response['responseCode'] == "001" && msg.indexOf('नहीं') == -1 && this.language == 'hi')) {
                    response["text"] = this.headerTitle.header;
                    response["vtext"] = this.headerTitle.header;
                    response["date"] = moment(this.todaydate).format("DDMMYYYY");
                    this.cmndeclaration.TamlismaJson = response;
                    this.cmndef.loaderend();
                    sessionStorage.CurrentPage = "/va/chat";
                    this.navctrl.navigateRoot("/va/chat");
                }
                else {
                    this.cmndef.loaderend();
                    this.cmndef.presentAlert(response['header'], response['message'], "downlddoc")
                }
            }, err => {
                console.log(err);
                this.cmndef.loaderend();
            })
        }
        // }
    }
}